import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { PlatformsService } from '../../../../../core/services/platforms.service';

@Component({
    selector: 'edit-marketplace-category-modal',
    templateUrl: './edit-marketplace-category.modal.html',
    styleUrls: ['./edit-marketplace-category.modal.scss'],
    standalone: false
})

export class EditMarketplaceCategoryModal {
  name = '';
  type = '';
  error = false;
  constructor(public dialogRef: MatDialogRef<EditMarketplaceCategoryModal>,
              @Inject(MAT_DIALOG_DATA) public data, public dialog: MatDialog,
              public platformsService: PlatformsService) {
    if (data && data.data) {
      this.name = data.data;
    }
    if (data && data.type) {
      this.type = data.type;
    }
  }

  saveCat() {
    if (this.name) {
      this.dialogRef.close({name: this.name});
    } else {
      this.error = true;
      setTimeout(() => {
        this.error = false;
      }, 5000);
    }
  }
}
